<template>
    <span class="flex shrink-0 -space-x-1.5" aria-hidden="true">
        <template v-for="user in props.users" :key="user.id">
            <img
                v-if="user.avatarUrl"
                :src="user.avatarUrl"
                alt=""
                class="size-7.5 shrink-0 rounded-full object-cover ring-2 ring-white"
            />
            <InitialsWithBackground
                v-else
                :first-name="user.firstName"
                :last-name="user.lastName"
                class="size-7.5 shrink-0 text-xs leading-7.5 ring-2 ring-white"
            />
        </template>
        <span
            v-for="index in placeholderCount"
            :key="index"
            class="inline-flex size-7.5 items-center justify-center rounded-full bg-gray-300 text-lg font-medium text-gray-500 ring-2 ring-white"
        >
            ?
        </span>
    </span>
</template>

<script setup lang="ts">
import InitialsWithBackground from '@/user/components/InitialsWithBackground.vue';
import { computed } from 'vue';
import type { UserReferenceMode } from './UserReferenceStatic.vue';

type AvatarUser = {
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl?: string;
};

type UserReferenceAvatarsProps = {
    users: AvatarUser[];
    mode: UserReferenceMode;
};

const props = defineProps<UserReferenceAvatarsProps>();

const placeholderCount = computed(() => {
    if (props.mode === 'Max-1') {
        return props.users.length === 0 ? 1 : 0;
    }
    return props.users.length === 0 ? 2 : 1;
});
</script>
